export default __webpack_public_path__ + "static/media/11_tag_non-smoking.e40668ff.svg";